import { render } from "./PageLoading.vue?vue&type=template&id=160188c5"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__